export default "__VITE_ASSET__B20BJLyv__"